import React from 'react';
import { useNavigate } from 'react-router-dom';
import ShoppingListEmptyState from '../EmptyStates/ShoppingListEmptyState';

// Recipe List Component
const RecipeList = ({ recipes }) => {
  const navigate = useNavigate(); // Using useNavigate for navigation
  const fallbackRecipeImage = '/no-image.png';

  const goToRecipePage = (recipeId: string) => {
    // Redirect to recipe detail page
    navigate(`/app/recipe/${recipeId}`);
  };

  if (!recipes || recipes.length === 0) {
    return <ShoppingListEmptyState />;
  }

  return (
    <div className="flex flex-wrap gap-3">
      {recipes.map((recipe) => (
        <div
          key={recipe.id}
          className="recipe-card flex items-center w-full sm:w-1/2 lg:w-1/3 border border-gray-300 rounded-lg shadow-md h-24 overflow-hidden cursor-pointer"
          onClick={() => goToRecipePage(recipe.id)}
        >
          {/* Clickable Image */}
          <img
            src={recipe.imageUrl || fallbackRecipeImage}
            alt={recipe.title}
            className="w-24 h-full object-cover rounded-l-lg"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = fallbackRecipeImage;
            }}
          />

          {/* Text block: title + servings */}
          <div className="flex-1 min-w-0 px-4">
            <h3 className="text-sm font-semibold truncate hover:underline">
              {recipe.title}
            </h3>
            <p className="text-sm text-gray-500">
              Servings: {recipe.totalServings}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecipeList;